import $ from "jquery";

const boxfilterconsument = () => {
  $(document).on("click", ".js-filter-label", function () {
    var ul = $(this).next();
    var arrow = $(this).find(".js-filter-icon");
    if (ul.css("display") === "none") {
      ul.show(300);
      // ul.css("display", "block");
      arrow.removeClass("hide");
      arrow.addClass("show");
    } else {
      ul.hide(300);
      // ul.css("display", "none");
      arrow.removeClass("show");
      arrow.addClass("hide");
    }
  });
};

try {
  boxfilterconsument();
} catch (error) {
  // eslint-disable-next-line no-console
  console.log(error);
}
